<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">合同基本信息</span>
          </div>
          <el-row>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="name" label="合同名称" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写合同名称"></el-input>
              </el-form-item>
              <span class="viewText" v-else>合同名称:{{ form.name }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="合同编号" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.no" placeholder="请填写合同编号"></el-input>
              </el-form-item>
              <span class="viewText" v-else>合同编号:{{ form.no }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item label="合同执行期" prop="date" v-if="getIsView()">
                <el-date-picker v-model="form.date" :disabled="!editMode" style="width: 100%" type="daterange"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" @input="dateChange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>合同执行期:{{ form.date }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="hospitalName" label="甲方(医疗机构)" v-if="getIsView()">
                <el-input disabled v-model="form.hospitalName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>甲方(医疗机构):{{ form.hospitalName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="乙方(配送企业)" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getSuppliers" @change="supplierChange" style="width:100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>乙方(配送企业):{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="manufacturerName" label="丙方(生产厂商)" v-if="getIsView()">
                <el-select v-model="form.manufacturerName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getManufacturers" @change="manufacturerChange" style="width:100%">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>丙方(生产厂商):{{ form.manufacturerName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="合同类型" v-if="getIsView()">
                <el-select :disabled="!editMode" v-model="form.category">
                  <el-option v-for="item in SpdContractCategoryOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8":class="!getIsView()?'viewCol':''" >
              <div v-if="getIsView()">
                <el-form-item v-if="form.category != 1" prop="distributionBatchName" label="集采批次">
                  <el-select v-model="form.distributionBatchName" :disabled="!editMode" placeholder="请选择" filterable
                    :filter-method="getDistributionBatchs" @change="distributionBatchChange" style="width:100%">
                    <el-option v-for="item in STATIC_DistributionBatchs" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-else label="集采批次">
                <el-select v-model="form.distributionBatchName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getDistributionBatchs" @change="distributionBatchChange" style="width:100%">
                  <el-option v-for="item in STATIC_DistributionBatchs" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              </div>
              <span class="viewText" v-else>集采批次:{{ form.distributionBatchName }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="合同总数量" v-if="getIsView()">
                <el-input disabled placeholder="合同总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>合同总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="合同总金额" v-if="getIsView()">
                <el-input disabled placeholder="合同总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>合同总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="创建人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>创建人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="state" label="合同状态" v-if="getIsView()">
                <el-select disabled v-model="form.state" style="width: 100%">
                  <el-option v-for="item in SpdContractStateOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>合同状态:{{ form.state }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14" >
              <el-form-item prop="fileInfos" label="" >
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? form.fileInfos : []" btnShowType="always"
                  :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange">
                </UploadFileList>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="dimensionType" label="合同维度">
                <el-select v-model="form.dimensionType" :disabled="!editMode" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in ContractDimensionOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">产品明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <!-- <el-table-column type="index" width="50"> </el-table-column> -->
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="supplierProductNo" v-if="form.dimensionType === 1" :key="'supplierProductNo'" label="供应商产品编码" min-width="180"></el-table-column>
            <el-table-column prop="productName" v-if="form.dimensionType === 1" :key="'productName'" label="产品名称" min-width="180"></el-table-column>
            <el-table-column prop="specName" v-if="form.dimensionType === 1" :key="'specName'" label="规格型号" min-width="180"></el-table-column>

            <el-table-column prop="productRegistCertNo" v-if="form.dimensionType === 2" :key="'productRegistCertNo'" label="注册证号" min-width="180"></el-table-column>
            <el-table-column show-overflow-tooltip v-if="form.dimensionType === 2" :key="'productRegistCertName'" prop="productRegistCertName" label="注册证名称"
              min-width="180"></el-table-column>
            <el-table-column show-overflow-tooltip v-if="form.dimensionType === 2" :key="'manufacturerName'" prop="manufacturerName" label="生产厂家"
              min-width="180"></el-table-column>
            <el-table-column v-if="form.dimensionType === 3" :key="'productCode'" prop="productCode" label="商品代码" min-width="120"></el-table-column>
            <el-table-column prop="price" label="含税价格（元）" min-width="120"></el-table-column>
            <el-table-column prop="number" label="协议采购量" min-width="120"></el-table-column>
            <el-table-column prop="amount" label="协议金额（元）" min-width="120"></el-table-column>
            <el-table-column prop="occupyNumber" label="已占用采购量" min-width="120">
              <template slot-scope="scope">
                <el-input-number v-if="$route.query.isEdit == 1" v-model="scope.row.occupyNumber" :min="0"
                  :controls="false" style="width: 100%;"></el-input-number>
                <span v-else> {{ scope.row.occupyNumber }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finishNumber" label="已完成采购量" min-width="120">
              <template slot-scope="scope">
                <el-input-number v-if="$route.query.isEdit == 1" v-model="scope.row.finishNumber" :min="0"
                  :controls="false" style="width: 100%;"></el-input-number>
                <span v-else> {{ scope.row.finishNumber }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finishAmount" label="已完成采购金额（元）" min-width="160"></el-table-column>
            <el-table-column prop="ratio" label="合同完成量占比" min-width="120">
              <!-- <template slot-scope="scope">
                {{ scope.row.ratio+'%' }}
              </template> -->
            </el-table-column>
          </el-table>
        </div>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
      <!-- <UpdatePrice ref="updatePrice" :show="updatePriceDisable" :id="form.id" :type="1" :details="form.productPriceDiffDetails" @close="updatePriceClose" @submit="updatePriceSubmit"></UpdatePrice> -->

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="800px"
        :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="form.dimensionType === 1">
            <el-col :span="8">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-select v-model="childForm.selevtValue" :disabled="!editMode" filterable placeholder="请选择"
                  :filter-method="getProductList" style="width: 100%" @change="productChange">
                  <el-option v-for="(item, index) in STATIC_SupplierProducts" :key="index" :label="item.no +
                    ' ' +
                    item.productName +
                    ' ' +
                    item.specName
                    " :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="productName" label="产品名称">
                <el-input disabled v-model="childForm.productName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>

            </el-col>
          </el-row>
          <el-row v-if="form.dimensionType === 3">
            <el-col :span="8">
              <el-form-item label="商品代码" prop="productCode">
                <el-input :disabled="!editMode" v-model="childForm.productCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="form.dimensionType === 2">
            <el-col :span="8">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <!-- <SelectTable :disabled="!editMode" :columns="productRegistCertColumns" :placeholder="'请选择注册证'" :innerName="childForm.productRegistCertNo" :dataList="STATIC_ProductRegistCerts" @filterMethod="getProductRegistCerts" @change="certChange" /> -->
                <el-input :disabled="!editMode" v-model="childForm.productRegistCertNo" @blur="certChange"
                  @keyup.enter.native="certChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="productRegistCertName" label="注册证名称">
                <el-input :disabled="!editMode" v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input :disabled="!editMode" v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item prop="number" label="协议采购量">
                <el-input :disabled="!editMode" @input="autoAmount" v-model="childForm.number"></el-input>
                <!-- <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number> -->
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item prop="price" label="含税价格（元）">
                <el-input :disabled="!editMode" @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="amount" label="协议金额（元）">
                <el-input :disabled="!editMode" v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick
            @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确
            定</el-button>
        </div>
      </el-dialog>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂
        存</my-button>
      <my-button v-if="editMode || $route.query.isEdit == 1" class="btn primary" type="primary" v-preventReClick
        @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetSpdContractById,
  SaveSpdContract,
  RejectSpdContract, GetProductRegistCerts
} from "@/api";
import {
  SpdContractCategoryOptions, SpdContractStateOptions, ContractDimensionOptions
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
// import UpdatePrice from "@/components/update-price";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
    // UpdatePrice,
    UploadFileList
  },
  data() {
    return {
      GetDataAction: GetSpdContractById,
      SaveDataAction: SaveSpdContract,
      reject: RejectSpdContract,
      form: {},
      SpdContractCategoryOptions: SpdContractCategoryOptions,
      SpdContractStateOptions: SpdContractStateOptions,
      ContractDimensionOptions: ContractDimensionOptions,
      rules: {
        name: [{
          required: true,
          message: '请输入合同名称',
          trigger: 'blur'
        }],
        no: [{
          required: true,
          message: '请输入合同编号',
          trigger: 'blur'
        }],
        date: [{
          required: true,
          message: '请选择合同执行期',
          trigger: 'blur'
        }],
        supplierName: [{
          required: true,
          message: '请选择乙方',
          trigger: 'blur'
        }],
        manufacturerName: [{
          required: true,
          message: '请选择丙方',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '请选择合同类型',
          trigger: 'blur'
        }],
        distributionBatchName: [{
          required: true,
          message: '请选择集采批次',
          trigger: 'blur'
        }],
      },
      childFormRules: {
        supplierProductNo: [{
          required: true,
          message: "请输入供应商产品编码",
          trigger: "blur"
        }],
        productCode: [{
          required: true,
          message: "请输入商品编码",
          trigger: "blur"
        }],
        productRegistCertNo: [{
          required: true,
          message: "请输入注册证号",
          trigger: "blur"
        }],
        productRegistCertName: [{
          required: true,
          message: "请输入注册证名称",
          trigger: "blur"
        }],
        manufacturerName: [{
          required: true,
          message: "请输入生产厂家",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入含税价格",
          trigger: "blur"
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur"
        },

        ],
        amount: [{
          required: true,
          message: "请输入金额",
          trigger: "blur"
        },],
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

    };
  },
  computed: {
    system_setting() {
      return this.$store.getters.system_setting;
    }
  },
  created() {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getSuppliers('');
    this.getManufacturers('');
    this.getDistributionBatchs('');
    this.getProductRegistCerts('');
  },
  methods: {
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate(id) {
      return new Promise((resolve, reject) => {
        this.GetDataAction({
          id
        }).then((res) => {
          // this.resetForm()
          this.form = res.returnData;
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.form.date = [this.form.startDate, this.form.endDate]

          this.initWorkFlowProperty(this.form);
          resolve(this.form);
        });
      })

    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading', false)
        });
      });
    },
    resetForm() {
      this.form = {

        hospitalName: this.userInfo.orgInfos[0].name,
        supplierId: "",
        supplierName: '',
        manufacturerId: "",
        manufacturerName: '',
        totalNumber: 0,
        totalAmount: 0,
        category: 0,
        state: 0,
        status: 2,
        remark: "",
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: [],
        orgCode: sessionStorage.getItem('orgId'),
        dimensionType: 2
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
    },
    handleDeleteChildForm() {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      if(this.form.dimensionType==1){
         this.childForm.selevtValue = this.childForm.supplierProductNo
      }
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        productRegistCertId: '',
        "productRegistCertNo": "",
        "productRegistCertName": "",
        "manufacturerId": '',
        "manufacturerName": '',
        "number": 1,
        "price": 0,
        "amount": 0,
        finishNumber: 0,
        finishAmount: 0,
        occupyNumber: 0,
        ratio: 0,
        "remark": "",
      };
    },
    cancelChildDialog() {
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.pushChildForm(true);
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList('')
    },
    pushChildForm(close) {
      let result = true
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        var childForm = this.childForm

        // 不存在则添加行记录
        var d = this.form.details.find(e => e.$index == this.childForm.$index)
        if (d) {
          this.form.details = this.form.details.map((item) => {
            if (item.$index == this.childForm.$index) {
               item.no = this.childForm.no
               item.productCode = this.childForm.productCode
               item.productName = this.childForm.productName
               item.specName = this.childForm.specName
              item.productRegistCertId = this.childForm.productRegistCertId
              item.productRegistCertNo = this.childForm.productRegistCertNo
              item.productRegistCertName = this.childForm.productRegistCertName
              item.manufacturerId = this.childForm.manufacturerId
              item.manufacturerName = this.childForm.manufacturerName
              item.number = this.childForm.number
              item.price = this.childForm.price
              item.amount = this.childForm.amount
              item.finishNumber = this.childForm.finishNumber
              item.finishAmount = this.childForm.finishAmount
              item.occupyNumber = this.childForm.occupyNumber
              item.ratio = this.childForm.ratio
            }

            return item
          })

        }
        else {
          var childForm = JSON.parse(JSON.stringify(this.childForm))
          childForm.$index = this.form.details.length + 1
          this.form.details.push(childForm)
          console.log(this.form.details);
          
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
        }
      });

      return result
    },
    autoAmount() {
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
    },
    autoTotalAmount() {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // change event
    dateChange(val) {
      this.$nextTick(() => {
        if (val == null) {
          this.form.startDate = "";
          this.form.endDate = "";
        } else {
          this.form.startDate = val[0];
          this.form.endDate = val[1];
        }

        // 结束日期<now  this.state = 1
        if (this.form.endDate) {
          var endDate = new Date(this.form.endDate);
          var endDateTime = endDate.getTime();
          var nowTime = (new Date()).getTime();
          if (endDateTime < nowTime) {
            this.form.state = 1
          }
          else {
            this.form.state = 0
          }
        }
      });
    },
    supplierChange(val) {
      this.form.supplierId = val
    },
    manufacturerChange(val) {
      this.form.manufacturerId = val
    },
    distributionBatchChange(val) {
      this.form.distributionBatchId = val
    },
    certChange() {
      // var cert = this.STATIC_ProductRegistCerts.find(item => item.No == val)
      if (!this.childForm.productRegistCertNo) return;
      GetProductRegistCerts({ no: this.childForm.productRegistCertNo }).then(res => {
        if (res.returnData.data.length > 0) {
          this.childForm.productRegistCertId = res.returnData.data[0].id
          this.childForm.productRegistCertName = res.returnData.data[0].name
          this.childForm.productRegistCertNo = res.returnData.data[0].no
          this.childForm.manufacturerId = res.returnData.data[0].manufacturerId
          this.childForm.manufacturerName = res.returnData.data[0].manufacturerName
        }
        // else {
        //   this.childForm.productRegistCertId = ''
        //   this.childForm.productRegistCertName = ''
        //   this.childForm.manufacturerId = ''
        //   this.childForm.manufacturerName = ''
        //   this.childForm.productRegistCertNo = ''
        // }
      })
    },
    productChange(row) {
      let product = this.STATIC_SupplierProducts.filter(res => res.id == row)
      this.childForm.productId = product[0].productId
      this.childForm.supplierProductId = product[0].id
      this.childForm.specId = product[0].specId
      this.childForm.productName = product[0].productName
      this.childForm.specName = product[0].specName
      this.childForm.supplierProductNo = product[0].no

      // this.getProductList(this.childForm.productRegistCertNo)
    },
    getProductList(keyWord) {
      // ,isEnabled:1
      this.getSupplierProducts({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
      });

      // this.getSupplierProducts({ keyWord: keyWord, pageIndex: 1, pageSize: 100,isEnabled:1 })
    },

    // 上传附件
    filesChange(fileList) {
      this.form.fileInfos = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
